import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgLogo = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520.7 175.7" sx={{
    ...sx
  }} {...other}><path d="M453.4 0c-26 0-47.1 8-62 24.6 2.1-5.8 3.2-12.8 3.4-21h-91c-19.8 0-31.2 8.7-39 31.2l4-31.2h-91.9c-16.8 0-28.4 8-32.6 23.8C133 9.1 112.7 0 87.1 0 38.5 0 6.8 28.1 1.1 88.1l-.7 7.6c-5 53.6 23.2 80.1 66.9 80.1s80.3-28.4 86-88.4l.7-7.6c1.3-13.8.3-25.7-2.5-35.9h41.2L180.9 145c-2.4 20.1 8.5 29.3 26.7 29.3s14.9-.7 19.1-1.4l14.7-129h48L277.6 145c-2.4 20.1 8.5 29.3 26.7 29.3s14.9-.7 19.1-1.4l14.6-129h23.6c8.2 0 14.8-1.9 19.9-5.7-7.4 13.1-12.3 29.7-14.2 49.8l-.7 7.6c-5 53.6 23.2 80.1 66.9 80.1s80.3-28.4 86-88.4l.7-7.6c5-53.3-23.1-79.7-66.8-79.7M105.3 76.5l-.5 5.7c-3.3 40.6-16.5 53.2-32.8 53.2S47 125.5 49.1 99l.5-5.9c3.3-40.4 16.5-53.2 32.8-53.2s25 10.2 22.9 36.6m366.3 0-.5 5.7c-3.3 40.6-16.5 53.2-32.8 53.2s-25-9.9-22.9-36.4l.5-5.9c3.3-40.4 16.5-53.2 32.8-53.2s25 10.2 22.9 36.6" style={{
      fill: "#eb001f"
    }} /></SvgIcon>;
};
const Memo = memo(SvgLogo);
export default Memo;